<template>
  <el-dialog title="添加/编辑设备"
    :visible.sync="$parent.editCom"
    width="40%">
    <el-form :model="ruleForm"
      :rules="rules"
      ref="ruleForm"
      label-width="100px"
      class="demo-ruleForm"
      style="width: 80%">
      <el-form-item label="设备名称"
        prop="name">
        <el-input v-if="clickItem.pointType=='PERSONAL'"
          v-model="ruleForm.name"></el-input>
        <p v-else>{{ruleForm.name}}</p>
      </el-form-item>
      <el-form-item label="设备地址"
        prop="address"
        v-if="clickItem.pointType=='PERSONAL'">
        <el-input v-model="ruleForm.address"></el-input>
      </el-form-item>
      <el-form-item label="保养周期"
        prop="period">
        <el-input-number v-model="ruleForm.period"
          :min="1"></el-input-number>
        <span style="margin-left:20px">天/次</span>
      </el-form-item>
      <el-form-item label="投运日期"
        prop="date1"
        v-if="clickItem.pointType=='PERSONAL'">
        <el-date-picker type="date"
          placeholder="选择日期"
          v-model="ruleForm.date1"
          value-format="timestamp"
          style="width: 100%;"></el-date-picker>
      </el-form-item>
      <el-form-item label="保养日期"
        prop="date2"
        v-if="clickItem.pointType=='PERSONAL'">
        <el-date-picker type="date"
          value-format="timestamp"
          placeholder="选择日期"
          v-model="ruleForm.date2"
          style="width: 100%;"></el-date-picker>
      </el-form-item>
      <el-form-item label="保养内容"
        prop="desc">
        <el-input type="textarea"
          v-model="ruleForm.desc"
          resize="none"
          rows="3"
          maxlength="20"
          show-word-limit></el-input>
      </el-form-item>
    </el-form>

    <span slot="footer"
      class="dialog-footer">
      <el-button @click="$parent.editCom = false">取 消</el-button>
      <el-button type="primary"
        @click="submitForm('ruleForm')"
        :loadin="btnLoading">确 定</el-button>
    </span>
  </el-dialog>

</template>

<script>
import api from "@/api";
export default {
  props: {
    clickItem: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      btnLoading: false,
      ruleForm: {
        name: "",
        address: "",
        desc: "",
        period: 1,
        date1: "",
        date2: "",
      },
      rules: {
        name: [
          { required: true, message: "请填写名称" },
          { whitespace: true, message: "名称不能为空" },
        ],
        address: [
          { required: true, message: "请填写位置" },
          { whitespace: true, message: "位置不能为空" },
        ],
        period: [{ required: true, message: "请填写保养周期" }],
        desc: [
          { required: true, message: "请填写保养内容" },
          { whitespace: true, message: "保养内容不能为空" },
          { min: 1, max: 20, message: "请输入不超过 20 个字", trigger: "blur" },
        ],
        date1: [
          {
            type: "date",
            required: true,
            message: "请选择日期",
            trigger: "change",
          },
        ],
        date2: [
          {
            type: "date",
            required: true,
            message: "请选择日期",
            trigger: "change",
          },
        ],
      },
    };
  },
  methods: {
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          return new Promise(async (resolve) => {
            let res = await api.patrolPointOperation({
              id: this.clickItem.id
                ? {
                    entityType: "INSPECTION_POINT",
                    id: this.clickItem.id,
                  }
                : null,
              name: this.ruleForm.name,
              maintenanceIntervals: this.ruleForm.period,
              location:
                this.clickItem.pointType == "PERSONAL"
                  ? this.ruleForm.address
                  : null,
              operationTime:
                this.clickItem.pointType == "PERSONAL"
                  ? this.ruleForm.date1
                  : null,
              maintenanceTime:
                this.clickItem.pointType == "PERSONAL"
                  ? this.ruleForm.date2
                  : null,
              pointType: this.clickItem.pointType,
              maintenanceContent: this.ruleForm.desc,
              sourceType: "MAINTENANCE",
              pointObjType: "DEVICE",
            });
            this.btnLoading = true;
            if (res && res.data.code == 200) {
              this.$message.success("提交成功！");
              this.btnLoading = false;
              this.$parent.editCom = false;
              this.$store.commit("SET_LOADING", true);
              setTimeout(() => {
                this.$parent.getList();
              }, 1000);
            } else if (res && res.data.code == "00003") {
              this.btnLoading = false;
            }
            resolve();
          });
        } else {
          return false;
        }
      });
    },
  },
  created() {
    if (this.clickItem.id) {
      this.ruleForm.name = this.clickItem.name;
      this.ruleForm.address = this.clickItem.location;
      this.ruleForm.period = this.clickItem.maintenanceIntervals;
      this.ruleForm.date1 = this.clickItem.operationTime;
      this.ruleForm.date2 = this.clickItem.maintenanceTime;
      this.ruleForm.desc = this.clickItem.maintenanceContent;
    }
  },
};
</script>

<style>
</style>